import { Body, Col, Row, Stack, SubHeading } from '@workramp/ui';
import { MessageLayoutWrapper } from './AdvancedSearchMessageLayout.styles';

type AdvancedSearchMessageLayoutProps = {
  title: string;
  subtitle: string;
};
export const AdvancedSearchMessageLayout = ({ title, subtitle }: AdvancedSearchMessageLayoutProps) => (
  <MessageLayoutWrapper>
    <Stack size={2}>
      <Row>
        <Col>
          <SubHeading level="md">{title}</SubHeading>
        </Col>
      </Row>
      <Row>
        <Col>
          <Body level="md">{subtitle}</Body>
        </Col>
      </Row>
    </Stack>
  </MessageLayoutWrapper>
);
